import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { StyledGrayButton, StyledDividerWithText } from "@Styled/Common";
import { MouseEventHandler, ReactChild } from "react";
import { useRouter } from "next/router";
import Spinner from "@Components/Pages/Common/Spinner";
import React from "react";
import Image from "next/image";

export interface RegistrationLayoutProps {
  title: string;
  subTitle?: string;
  dividerText?: string;
  buttonText?: string;
  loginModal?: boolean;
  onButtonClicked?: MouseEventHandler<HTMLButtonElement>;
  children: ReactChild;
  otpSpinner?: Boolean;
}

export default function RegistrationLayout({
  title,
  children,
  dividerText,
  buttonText,
  subTitle,
  loginModal,
  onButtonClicked,
  otpSpinner,
}: RegistrationLayoutProps) {
  const router = useRouter();
  return (
    <div
      style={{
        height: loginModal ? "calc(100vh - 56px)" : "",
        paddingTop: loginModal ? "" : "1.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        >
          {/* <BrandImage
            sx={{ width: { xs: "7rem", md: "9rem", cursor: "pointer" } }}
            src="/static/images/econut-logo.png"
            onClick={() => router.push("/")}
          /> */}
          <Image
            src="/static/images/econut-logo1.png"
            alt="econut-logo"
            width={150}
            height={40}
            objectFit="contain"
            style={{ cursor: "pointer" }}
            onClick={() => router.push("/")}
          />
          <Grid
            item
            xs={12}
            sx={{
              boxShadow: 2,
              padding: "1rem",
              border: "1px solid lightgray",
              borderRadius: "5px",
              marginTop: "1.2rem",
              marginBottom: "1rem",
              width: { xs: "100%", sm: "60%", md: "40%" },
            }}
          >
            <Box marginBottom="1rem">
              <Typography variant="subtitle1" textAlign="center">
                {title}
              </Typography>
              {subTitle && (
                <Typography
                  textAlign="center"
                  fontSize="0.8rem"
                  marginBottom="1rem"
                >
                  {subTitle}
                </Typography>
              )}
            </Box>
            {children}
          </Grid>
          {dividerText && (
            <Grid
              sx={{
                width: { xs: "100%", sm: "60%", md: "40%" },
              }}
            >
              <StyledDividerWithText>{dividerText}</StyledDividerWithText>
              {buttonText && !!onButtonClicked && (
                <StyledGrayButton
                  onClick={onButtonClicked}
                  sx={{
                    background: "lightgray",
                    color: "unset",
                    marginTop: "1rem",
                  }}
                  fullWidth
                  color="secondary"
                >
                  {otpSpinner ? <Spinner spinColor={true} /> : ""} {buttonText}
                </StyledGrayButton>
              )}
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
}
